module.exports = __webpack_public_path__ + "img/groupModeMenu.8ac14871.svg";